<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iNVjMw/tc-custom/9781504076920.jpg?1705838700798" alt="This image is the cover for the book Book of the Beast, The Book of the Beast"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of the Beast, The Book of the Beast
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The adventures of a shapeshifting beast living amongst humanity are chronicled in this acclaimed science fiction trilogy.</b><br/><br/><b><i>The Orphan</i></b><br/> No one, not even the beast itself, knows where it comes from or what it is. Witnesses’ descriptions vary. A big dog, a wolf, a lynx. A cross between a gorilla and a bear. Powerful jaws like a shark. A fiend out of hell . . .<br/><br/> After a startling encounter in a Michigan barn, the beast transforms into a five-year-old boy named Robert Lee Burney and is adopted by a farmer and his wife. He begins learning about human society and lives peacefully among them until an attack on the farm forces him to flee . . .<br/><br/><b><i>The Captive</i></b><br/> The shapeshifting beast’s new human form is a handsome young man named Barry Golden. He finds love, but it leads him down a dangerous path resulting in imprisonment in a seedy sideshow with little hope of escape . . .<br/><br/><b><i>The Beast</i></b><br/> Barry has settled into a new life in New Mexico with a family and a job as a reporter. But that could all change when the beast discovers he’s not the only one of his kind on Earth. He must find a mate and prepare for something called The Leap . . .<br/><br/> Meanwhile, another shapeshifter on the other side of the country saves a dying man from cancer. He wants to marry her, but she feels a call from the Other, someone waiting for her . . .<br/><br/> A terrific read for fans of Ray Bradbury, Clifford Simak, and Theodore Sturgeon.<br/><br/><b>Praise for Robert Stallman</b><br/><br/> “Stallman reminds me of Ray Bradbury . . . A big talent.” —Peter Straub, author of <i>Ghost Story</i><br/><br/> “A vision of the perilous coming-together of a man-soul and monster-soul in us all. The result is an exciting blend of love and violence, of sensitivity and savagery.” —Fritz Leiber, author of <i>Swords and Deviltry</i><br/><br/> “<i>The Orphan</i> is frank, violent, and at times erotic in jarring, unexpected ways. The bottom line? Highly recommended.” —<i>Black Gate</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Stallman
      </h2>
      
      <p class="authorDescription body article">Robert Stallman (1930&ndash;1980) was an American literary critic and science fiction writer. Author of the highly-praised Beast series, he was also an academic authority on William Morris. Born in Kankakee, Illinois, Stallman received bachelor&rsquo;s and master&rsquo;s degrees from the University of New Mexico and was an English professor at Western Michigan University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e47eb408